import React from 'react';
import { Link } from 'react-router-dom';
import PriceSparkline from './PriceSparkline';
import useNow from '../../hooks/useNow';
import { estimateHead, currentProducerAt } from '../../utils/chainClock';

const formatUsd = (value, digits = 0) =>
  `$${(Number(value) || 0).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;

const Stat = ({ label, children, mono = false, divider = false }) => (
  <div className={divider ? 'border-t border-gray-100 pt-4' : ''}>
    <div className="stat-label">{label}</div>
    <div className={`text-base font-medium mt-1 truncate ${mono ? 'font-mono' : ''}`}>{children}</div>
  </div>
);

const colClass = 'flex-[1_1_260px] px-6 py-5 flex flex-col gap-4 border-b md:border-b-0 md:border-r border-gray-200';

/**
 * Panel de estadísticas de red de la portada (maqueta "Classic Explorer"):
 * precio + market cap · head block + LIB · productor actual + volumen · gráfico 30 días.
 */
const NetworkStats = ({ blockchainInfo, active, currentPrice, symbol, blockchainService }) => {
  const now = useNow(500);
  const est = estimateHead(blockchainInfo, now);
  // Mismo cálculo que la tira y la lista de bloques, para que no se contradigan
  const currentProducer = currentProducerAt(blockchainInfo, active, now);
  const price = parseFloat(currentPrice?.price) || 0;
  return (
    <section aria-label="Network stats" className="card flex flex-wrap overflow-hidden">
      <div className={colClass}>
        <Stat label={`${symbol} Price`}>{formatUsd(price, price < 1 ? 6 : 4)}</Stat>
        <Stat label="Market Cap" divider>{formatUsd(currentPrice?.marketcap)}</Stat>
      </div>
      <div className={colClass}>
        <Stat label="Head Block" mono>
          {est ? est.headNum.toLocaleString('en-US') : '—'}
        </Stat>
        <Stat label="Last Irreversible" mono divider>
          {est ? est.lib.toLocaleString('en-US') : '—'}
        </Stat>
      </div>
      <div className={colClass}>
        <Stat label="Current Producer">
          {currentProducer ? <Link to={`/account-detail/${currentProducer}`} className="link">{currentProducer}</Link> : '—'}
        </Stat>
        <Stat label="24h Volume" divider>{formatUsd(currentPrice?.volume)}</Stat>
      </div>
      <div className="flex-[1_1_300px] px-6 py-5 min-w-0">
        <div className="stat-label">{symbol} price · 30 days</div>
        <PriceSparkline blockchainService={blockchainService} symbol={symbol} />
      </div>
    </section>
  );
};

export default React.memo(NetworkStats);
